import { render, staticRenderFns } from "./zan.vue?vue&type=template&id=d530cef6&scoped=true"
import script from "./zan.vue?vue&type=script&lang=js"
export * from "./zan.vue?vue&type=script&lang=js"
import style0 from "./zan.vue?vue&type=style&index=0&id=d530cef6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d530cef6",
  null
  
)

export default component.exports